import { Button, Container, TextField, Typography, Backdrop, CircularProgress, Dialog } from "@mui/material";
import React, { useState } from "react";
import { Context } from "../../App";
import { useNavigate } from "react-router-dom";
import ForgotPwd from "./ForgotPwd";


export default function LoginForm({onLogin}) {
    const navigate = useNavigate();
    const { setUserId, setIsConnected } = React.useContext(Context);
    const [loading, setLoading] = React.useState(false);
    const [msg, setMsg] = React.useState('');
    const [mail, setMail] = React.useState('');
    const [password, setPassword] = React.useState('');

    const [open, setOpen] = useState(false);
    const [action, setAction] = useState('');

    function manageDialog(open, action = '') {
        setOpen(open);
        setAction(action);
    }

    async function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);

        const query = new URLSearchParams({uuid: localStorage.getItem('anonUserId') || ''}).toString();

        fetch(`${process.env.REACT_APP_API_URL}/login?`+query, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Basic ${btoa(mail + ':' + password)}`
            }
        })
        .then(async response => {
            if (!response.ok) {
                const text = await response.text();
                setMsg((response.status!==500 ? text : null) || 'Erreur lors de la connexion. Veuillez réessayer.');
            }else {
                localStorage.setItem('token', response.headers.get('x-auth-token'));
                const json = await response.json();
                localStorage.setItem('user', json._id);
                setUserId(json._id);
                setIsConnected(true);
                setMsg('');
                !!onLogin? onLogin() : navigate(-1)
            }
            setLoading(false);
        })
        .catch(error => {
            setLoading(false);
            console.error('Erreur lors de la connexion :', error);
            alert('Une erreur est survenue. Veuillez réessayer plus tard.');
        });
    }

    return <>
    <Container component="form" onSubmit={handleSubmit} maxWidth="sm" sx={{ display: 'flex', flexDirection: 'column', mt: {xs:2, sm: 4}, rowGap: 2, minWidth: { xs: 'auto', sm: 400 }, px: 0 }}>
        <Typography variant="h4" align="center" sx={{ mb: 2 }}>Je me connecte</Typography>

        {msg && <Typography variant="body1" color="error" sx={{ mb: 2 }}>{msg}</Typography>}

        <TextField fullWidth label="Adresse e-mail" variant="outlined" value={mail} required onBlur={() => setMail(mail.trim())} onChange={(e) => setMail(e.target.value)} />

        <TextField fullWidth type="password" label="Mot de passe" variant="outlined" value={password} required onChange={(e) => setPassword(e.target.value)} />

        <Typography variant="body2" sx={{ color: 'focus.main', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => manageDialog(true, 'forgot pwd')}>
            Mot de passe oublié ?
        </Typography>

        <Button type="submit" variant="contained" color="primary" sx={{ alignSelf: 'center', px: 5, mb: 2 }}>Connexion</Button>

        <Backdrop open={loading}><CircularProgress /></Backdrop>
    </Container>


    <Dialog open={open} onClose={() => manageDialog(false)} maxWidth='md' fullWidth>
        {action === 'forgot pwd' && <ForgotPwd {...{close:() => manageDialog(false)}}/>}
    </Dialog>

    </>
}